import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import Header from "../components/header/Header";
import Nav from "../components/nav/Nav";
import ScrollToTop from "../components/scroll-to-top/ScrollToTop";
import { fetchActiveTableCount } from "../reduxStore/slices/tableSlice";
import "./PosLayout.css";

function PosLayout(props) {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (user?.storeId) {
      dispatch(fetchActiveTableCount(user.storeId));
    }
  }, [dispatch, user?.storeId]);

  return (
    <div>
      <Nav openNav={open} onCloseNav={() => setOpen(false)} />
      <Header openNav={open} onOpenNav={() => setOpen(!open)} />
      <Box
        id="main-scroll"
        className="outlet-container"
        style={{
          width: open ? "calc(100% - 90px)" : "100%",
          marginLeft: open ? "90px" : 0,
        }}
      >
        <ScrollToTop />
        <Outlet />
      </Box>
    </div>
  );
}

export default PosLayout;
